import React from "react";
import { Div } from "glamorous";
import { BLACK_COLOR, SECONDARY_COLOR } from "../../styles/variables";
import { css } from "glamor";
import Logo from "../logo/Logo";

const LoadingScreen = ({ loaded }) => {
  return (
    <Div
      css={{
        position: "fixed",
        background: BLACK_COLOR,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10002,
        transition: "opacity .5s, transform 0s .5s",
        transform: loaded ? "translateX(200%)" : "translateX(0)",
        opacity: loaded ? 0 : 1
      }}>
      <Div css={{ position: "relative" }}>
        <Logo
          height={30}
          width={140}
          styles={{
            position: "absolute",
            left: -70,
            bottom: 20,
            transition: ".5s",
            opacity: loaded ? 0 : 1
          }}
          white
        />
        <Div
          css={{
            height: 3,
            width: 0,
            left: -50,
            position: "absolute",
            backgroundColor: SECONDARY_COLOR,
            transformOrigin: "center right",
            transition: ".5s .3s",
            opacity: loaded ? 0 : 1,
            animation: !loaded
              ? `${css.keyframes({
                  "0%": { width: 0 },
                  "50%": { width: 100, transform: `scaleX(1)` },
                  "100%": { transform: `scaleX(0)`, width: 100 }
                })} 1.5s infinite cubic-bezier(.82,-0.09,.21,.99)`
              : null
          }}
        />
      </Div>
    </Div>
  );
};
export default LoadingScreen;



// WEBPACK FOOTER //
// ./src/components/loadingscreen/LoadingScreen.js